import { render, staticRenderFns } from "./index.vue?vue&type=template&id=729a01b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=729a01b4&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729a01b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729a01b4')) {
      api.createRecord('729a01b4', component.options)
    } else {
      api.reload('729a01b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=729a01b4&scoped=true", function () {
      api.rerender('729a01b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PropsImg/index.vue"
export default component.exports